import React from 'react'

function Tour14() {
  return (
    <div>Tour14</div>
  )
}

export default Tour14